import React from 'react'
import { StaticQuery, Link } from 'gatsby'
import _ from 'lodash'
import styled from 'styled-components'
import SEO from '../components/seo'

const BlogContent = styled.div`
  margin: 3em 0;

  h1 {
    margin: 3em 0;
    font-weight: bold;
  }

  div {
    max-width: 300px;
  }

  a {
    text-transform: uppercase;
    display: block;
  }
`

const Personal = () => (
  <StaticQuery
    query={graphql`
      query PersonalNavigationQuery {
        allPrismicPersonal(filter: {data: {indexed: {nin: true}}}, sort: {order: ASC, fields: data___title___text}) {
          edges {
            node {
              slugs
              uid

              data {
                title {
                  text
                }
                indexed
              }

            }
          }
        }
      }
    `}
    render={data => (
      <>
        <SEO
          title="personal"
          metaImage="https://www.datocms-assets.com/27639/1589310565-d2a63f03fb62e63631402684fdf80ee9375853mv2d1150767s2.jpg?auto=format&dpr=1&w=1150"
          keywords={[
            `personal photography`,
            `fbz`,
            `jorja smith`,
            `asap rocky`,
            `magista`,
          ]}
        />
        <BlogContent>
          <h1>Personal /</h1>

          {data.allPrismicPersonal.edges.map(({ node }) => (
               <div>
                 <Link className="test" to={`/${node.uid}`}>{node.data.title.text} </Link>
             </div>
        ))}
        </BlogContent>
      </>
    )}
  />
)

export default Personal
